import MessagesRequestsContent from '../hoc/messages-requests';
import MessagesList from '../hoc/messages-requests-content';
import Message from '../hoc/message';

import ROUTES from '../routes';

const MessagesRequests = {
  path: ROUTES.MESSAGES_REQUEST,
  element: <MessagesRequestsContent />,
  children: [
    {
      path: ROUTES.MESSAGES_REQUEST_UNREAD,
      element: (
        <MessagesList
          path={ROUTES.MESSAGES_REQUEST_UNREAD}
          matchPath={ROUTES.MESSAGES_REQUEST_UNREAD_MESSAGE}
        />
      ),
      children: [
        {
          path: ROUTES.MESSAGES_REQUEST_UNREAD_MESSAGE,
          element: <Message messageType="new" type="requests" />,
        },
      ],
    },
    {
      path: ROUTES.MESSAGES_REQUEST_IN_PROGRESS,
      element: (
        <MessagesList
          path={ROUTES.MESSAGES_REQUEST_IN_PROGRESS}
          matchPath={ROUTES.MESSAGES_REQUEST_IN_PROGRESS_MESSAGE}
        />
      ),
      children: [
        {
          path: ROUTES.MESSAGES_REQUEST_IN_PROGRESS_MESSAGE,
          element: <Message messageType="in-progress" type="requests" />,
        },
      ],
    },
    {
      path: ROUTES.MESSAGES_REQUEST_COMPLETED,
      element: (
        <MessagesList
          path={ROUTES.MESSAGES_REQUEST_COMPLETED}
          matchPath={ROUTES.MESSAGES_REQUEST_COMPLETED_MESSAGE}
        />
      ),
      children: [
        {
          path: ROUTES.MESSAGES_REQUEST_COMPLETED_MESSAGE,
          element: <Message messageType="completed" type="requests" />,
        },
      ],
    },
    {
      path: ROUTES.MESSAGES_REQUEST_ALL,
      element: (
        <MessagesList
          path={ROUTES.MESSAGES_REQUEST_ALL}
          matchPath={ROUTES.MESSAGES_REQUEST_ALL_MESSAGE}
        />
      ),
      children: [
        {
          path: ROUTES.MESSAGES_REQUEST_ALL_MESSAGE,
          element: <Message messageType="all" type="requests" />,
        },
      ],
    },
  ],
};

export default MessagesRequests;
